import type { ISpaceRecordBase, SpaceSubscriptionT, SubscriptionPlanTypeT, WorkspaceType } from "@anydo/interfaces";
import { makePostRequest } from "./makePostRequest";

export type IFetchSyncHttpCreateWorkspace = {
  id: string;
  spaceName: string;
  spaceDescription?: string;
  spaceType?: WorkspaceType;
  metadata?: ISpaceRecordBase["metadata"];
} & AnySubscription;

type AnySubscription =
  | {
      subscriptionParams: {
        type: SubscriptionPlanTypeT;
        planId: string;
        trialPeriodDays?: number;
        stripeData?: { setupIntentId: string };
        countryCode: string;
      };
    }
  | {
      subscription: SpaceSubscriptionT;
    };

export async function fetchSyncHttpCreateWorkspace({
  authToken,
  id,
  spaceName,
  spaceDescription = "",
  spaceType,
  metadata,
  signal,
  ...rest
}: {
  authToken: string | null;
  signal?: AbortSignal;
} & IFetchSyncHttpCreateWorkspace): Promise<ISpaceRecordBase> {
  const subscription = "subscription" in rest ? rest.subscription : undefined;
  const subscriptionParams = "subscriptionParams" in rest ? rest.subscriptionParams : undefined;

  const resp = await makePostRequest({
    requestName: "fetchSyncHttpCreateWorkspace",
    authToken,
    path: "/me/spaces/create",
    body: {
      id,
      name: spaceName,
      description: spaceDescription,
      spaceType,
      subscription,
      subscriptionParams,
      metadata,
    },
    signal,
  });

  return (await resp.json()) as ISpaceRecordBase;
}
